import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateService } from '@ngx-translate/core';
import { TeamMessageService } from '../service/team-message.service';
import {
  Router,
  RouterLink,
  RouterOutlet
} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import {ThemePalette} from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {ProgressBarMode, MatProgressBarModule} from '@angular/material/progress-bar';
import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-team-message',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatCardModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    MatProgressBarModule,
    TranslateModule,
  ],
  templateUrl: './team-message.component.html',
  styleUrl: './team-message.component.css'
})
export class TeamMessageComponent {
  color : ThemePalette = 'accent';
  apexId!:string;
  mode: ProgressBarMode = 'indeterminate';
  isLoading = false;
  teamMessageArray!: any[];
  teamMessageNotReadArray!: any[];
  teamMessageReadArray!: any[];
  terminalName!:string;
  subRegionName!:string;
  driverId = 0;
  browserLangToUse = '';
  constructor(        
    private router: Router,    
    private teamMessageService: TeamMessageService,
    translate: TranslateService, 
    private location: Location,
  ) {     
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse);
    this.browserLangToUse = browserLangToUse; 
  }
  
  ngOnInit(): void {
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      console.log(`team-message not override apex id`);
      this.pageInitialization();
    } 
    else{
      console.log(`team-message override apex id`);
      this.pageInitializationOverride(overrideObjectString);
    }
  }
    
  private pageInitialization(): void {
    this.isLoading = true;
    let apexid = localStorage.getItem("apexid"); 
    this.apexId = apexid!;
    if(apexid !== null){
      this.getTeamMessageByApexId(apexid);
    }
    
  }
  private pageInitializationOverride(overrideObjectString:string): void{
    let overrideObject = JSON.parse(overrideObjectString);
    let apexid = overrideObject.apexid;
    this.apexId = apexid;
    this.isLoading = true;    
    if(overrideObject.dashboardTeamMessageDetails.length === 0){
      this.teamMessageArray = [];
    }
    else if(overrideObject.dashboardTeamMessageDetails[0] === null){
      this.teamMessageArray = [];
    }
    else{
      this.teamMessageArray = overrideObject.dashboardTeamMessageDetails;
      for (const teamMessage of this.teamMessageArray){
        teamMessage.isOpen = false;
        teamMessage.fullBody = '';
        teamMessage.isLoading = false;
        teamMessage.dateTime = this.formatDateTime(teamMessage.created_On);
      }
    }
    let driverId = overrideObject.driverId;
    if(driverId !== null){
      this.driverId = Number(driverId);
    }  
    this.isLoading = false; 
    
  }
  getTeamMessageByApexId(apexid:string):void{
    this.teamMessageService.getTeamMessageByApexId(apexid).subscribe(responseTeamMessageObject => {            
      if(responseTeamMessageObject.length === 0){
        this.teamMessageArray = [];
      }
      else if(responseTeamMessageObject[0].dashboardTeamMessageDetails[0] === null){
        this.teamMessageArray = [];
      }
      else{        
        this.teamMessageArray = responseTeamMessageObject[0].dashboardTeamMessageDetails;        
        for (const teamMessage of this.teamMessageArray){
          teamMessage.isOpen = false;
          teamMessage.fullBody = '';
          teamMessage.isLoading = false;
          teamMessage.dateTime = this.formatDateTime(teamMessage.created_On);
        }      
        this.terminalName = responseTeamMessageObject[0].driver.terminal.terminalName;        
        this.driverId = responseTeamMessageObject[0].driver.driver_Id;
      }      
      this.isLoading = false;
    });
  }
  RevealHiddenOverflow(d:any) {
    d.classList.toggle("truncate")
  }

  public readIsVisited = false;
  public readCheckVisited(teamMessageId: number) {
    // reverse the value of property
    this.readIsVisited = !this.readIsVisited;

  }
  public notReadIsVisited = false;
  public notReadCheckVisited(teamMessage: any) {
    // reverse the value of property
    this.notReadIsVisited = !this.notReadIsVisited;

    if(teamMessage.readTime === null){
      this.markRead(teamMessage.teamMessage_Id);
      this.teamMessageNotReadArray.filter((e:any) => e.teamMessage_Id === teamMessage.teamMessage_Id)[0].readTime = 'read';
    }

    
    
    

  }

  public cardVisited(teamMessageVisited: any) {
    
    
    for (const teamMessage of this.teamMessageArray){
      if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){
        teamMessage.isOpen = !teamMessage.isOpen;
        // teamMessage.readTime = 'read';
      }
      
    }
    
    if(teamMessageVisited.fullBody === ''){

      for (const teamMessage of this.teamMessageArray){
        if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){
          teamMessage.isLoading = true;
        }
        
      }

      this.teamMessageService.getTeamMessageByTeamMessageId(teamMessageVisited.teamMessage_Id).subscribe(responseTeamMessage =>{
      
        for (const teamMessage of this.teamMessageArray){
          if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){
            teamMessage.fullBody = responseTeamMessage.body;
            teamMessage.isLoading = false;
            // teamMessage.readTime = 'read';
          }
          
        }
  
      });
      this.markRead(teamMessageVisited.teamMessage_Id);
    }
    
    
  }

  public notReadCardVisited(teamMessageVisited: any) {
    
    
    for (const teamMessage of this.teamMessageNotReadArray){
      if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){
        teamMessage.isOpen = !teamMessage.isOpen;
        // teamMessage.readTime = 'read';
      }
      
    }
    
    if(teamMessageVisited.fullBody === ''){

      for (const teamMessage of this.teamMessageNotReadArray){
        if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){
          teamMessage.isLoading = true;
        }
        
      }

      this.teamMessageService.getTeamMessageByTeamMessageId(teamMessageVisited.teamMessage_Id).subscribe(responseTeamMessage =>{
      
        for (const teamMessage of this.teamMessageNotReadArray){
          if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){
            teamMessage.fullBody = responseTeamMessage.body;
            teamMessage.isLoading = false;
            // teamMessage.readTime = 'read';
          }
          
        }
  
      });
      // this.markRead(teamMessageVisited.teamMessage_Id);
      let readObject: any = {teammessage_id: teamMessageVisited.teamMessage_Id, Driver_Id: this.driverId, };
      this.teamMessageService.markReadTeamMessage(readObject).subscribe(responseTeamMessageObject => {
        
        for (const teamMessage of this.teamMessageNotReadArray){
          if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id){            
            teamMessage.readTime = responseTeamMessageObject.readTime;
          }
          
        }

        console.log(`team message mark read complete`);
      });
    }
    
    
  }

  public readCardVisited(teamMessageVisited: any) {
    
    for (const teamMessage of this.teamMessageReadArray){
      if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id)
      teamMessage.isOpen = !teamMessage.isOpen;
    }
    if(teamMessageVisited.fullBody){

    }
    else{
      this.teamMessageService.getTeamMessageByTeamMessageId(teamMessageVisited.teamMessage_Id).subscribe(responseTeamMessage =>{
      
        for (const teamMessage of this.teamMessageReadArray){
          if(teamMessageVisited.teamMessage_Id === teamMessage.teamMessage_Id)
          teamMessage.fullBody = responseTeamMessage.body;
        }
  
      });
    }
  }

  public markRead(teamMessageId: number) {
    let readObject: any = {teammessage_id: teamMessageId, Driver_Id: this.driverId, };
    this.teamMessageService.markReadTeamMessage(readObject).subscribe(responseTeamMessageObject => {
      
      console.log(`team message mark read complete`);
    });
  }

  alphabetically(ascending: boolean) {
    return function (a:any, b:any) {
      // // equal items sort equally
      // if (a === b) {
      //     return 0;
      // }
  
      // // nulls sort after anything else
      // if (a === null) {
      //     return -1;
      // }
      // if (b === null) {
      //     return 1;
      // }
  
      // // otherwise, if we're ascending, lowest sorts first
      // if (ascending) {
      //     return a < b ? -1 : 1;
      // }
  
      // // if descending, highest sorts first
      // return a < b ? 1 : -1;

      if (a === null) {
        return -1;
      }
      else {
        if (b === null) {
          return 1;
        }
        else {
          return -1;
        }
      }
    

    };
  }

  goToDetail(teamMessage: any): void {
    this.router.navigate(['/team-message-detail', { message_id: teamMessage.teamMessage_Id, 
      driver_id: this.driverId, sender: teamMessage.author, 
      time: teamMessage.created_On, readTime: teamMessage.readTime,
      getAttachmentS3Url: teamMessage.getAttachmentS3Url  }]);
  }


  private formatDateTime(created_On: string): string {
    // throw new Error('Function not implemented.');
    // 2024-03-28T05:16:46.644514Z
    let formatedDateTime = '';
    let date = new Date(created_On);
    // 3/28/2024
    let datePart = date.toLocaleDateString();
    let timePart = date.toLocaleTimeString().replace(/(.*)\D\d+/, '$1');
    formatedDateTime = datePart + ' ' + timePart;
    return formatedDateTime;
  }

  backClicked() {
    this.location.back();
  }
}


